import { name } from "./__init__";
import { fromJS } from "immutable";
import constants from "../../utils/constants";
import {
  fetchBookingEngineData,
  fetchARI,
  fetchPropertyData,
  buildARIRequestParams,
  saveAriParamsToStorage,
  buildQueryTrackData,
} from "./configurer";
import { requestReservation, requestCountries } from "../../utils/witbookingApi";
import { changeLocale as changeLocaleIntl } from "~/redux/modules/intl";
import {
  saveToLocalStorage,
  getFromLocalStorage,
  removeFromSessionStorage,
  getFromSessionStorage,
  saveToSessionStorage,
} from "../../utils/misc"; // eslint-disable-line
import get from "lodash/get";
import { actions as reservationManagerActions } from "../ReservationManager";
import { isDisplayActiveSelector } from "./selectors";
import { sendQuery } from "../../utils/EngineDataColllector/EngineDataCollector";
const LOAD_BOOKING_ENGINE_DATA = `${name}/LOAD_BOOKING_ENGINE_DATA`;
const LOAD_BOOKING_ENGINE_DATA_SUCCESS = `${name}/LOAD_BOOKING_ENGINE_DATA_SUCCESS`;
const LOAD_BOOKING_ENGINE_DATA_ERROR = `${name}/LOAD_BOOKING_ENGINE_DATA_ERROR`;

const LOAD_RESERVATION_DATA = `${name}/LOAD_RESERVATION_DATA`;
const LOAD_RESERVATION_DATA_SUCCESS = `${name}/LOAD_RESERVATION_DATA_SUCCESS`;
const LOAD_RESERVATION_DATA_ERROR = `${name}/LOAD_RESERVATION_DATA_ERROR`;

const LOAD_ARI = `${name}/LOAD_ARI`;
const LOAD_ARI_SUCCESS = `${name}/LOAD_ARI_SUCCESS`;
const LOAD_ARI_ERROR = `${name}/LOAD_ARI_ERROR`;

const LOAD_LOCALE_DATA_SUCCESS = `${name}/LOAD_LOCALE_DATA_SUCCESS`;

const LOAD_COUNTRIES = `${name}/LOAD_COUNTRIES`;
const LOAD_COUNTRIES_SUCCESS = `${name}/LOAD_COUNTRIES_SUCCESS`;
const LOAD_COUNTRIES_ERROR = `${name}/LOAD_COUNTRIES_ERROR`;

const LOAD_ANALYTICS_SUCCESS = `${name}/LOAD_ANALYTICS_SUCCESS`;
const LOAD_TRIPADVISOR_SUCCESS = `${name}/LOAD_TRIPADVISOR_SUCCESS`;
const LOAD_EXTERNAL_MARKUP_SUCCESS = `${name}/LOAD_EXTERNAL_MARKUP_SUCCESS`;

const CHANGE_CONFIGURATION = `${name}/CHANGE_CONFIGURATION`;
const CHANGE_PROPERTY_TICKER = `${name}/CHANGE_PROPERTY_TICKER`;
const CHANGE_LOCALE = `${name}/CHANGE_LOCALE`;
const CLEAR_DATA = "CLEAR_DATA";
const CLEAR_LOADED_RESERVATIONS = "CLEAR_LOADED_RESERVATIONS";
const GLOBAL_LOADING_ON = `${name}/GLOBAL_LOADING_ON`;
const GLOBAL_LOADING_OFF = `${name}/GLOBAL_LOADING_OFF`;
// TODO: Move to RoomSelection reducer
const TOGGLE_CHILDREN = `${name}/TOGGLE_CHILDREN`;
const SELECT_DISPLAY_ELEMENT = `${name}/SELECT_DISPLAY_ELEMENT`;
const CREATED_RESERVATION = `${name}/CREATED_RESERVATION`;

const SET_TRACKING_DATA = `${name}/SET_TRACKING_DATA`;
const TOGGLE_PROMOTIONS = `${name}/TOGGLE_PROMOTIONS`;
const TOGGLE_BOOKING_FORM_SUMMARY = `${name}/TOGGLE_BOOKING_FORM_SUMMARY`;

/*
 * CONFIGURATION EXAMPLE
 * */

export const initialState = fromJS({
  configuration: null,
  hotelData: null,
  [constants.PROPERTY_ARI_KEY]: false,
  error: null,
  loaded: false,
  propertyTicker: false,
  ariLoading: false,
  countries: false,
  reservationCreated: !!getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.RESERVATION_ID),
  analyticsLoaded: false,
  tripAdvisorLoaded: false,
  externalMarkupLoaded: false,
  trackingData: {},
  expandedPromotions: false,
});

export function childrenToggled({
  ticker,
  children: originalChildren,
  closeOthers,
  activeOnly,
  oneTime,
}) {
  return (dispatch, getState) => {
    const globalState = getState();
    const baseTicker = globalState[name].get("propertyTicker");

    const displayActive = isDisplayActiveSelector(globalState);

    let children = originalChildren;
    let element = false;
    if (displayActive) {
      if (originalChildren === "calendar") {
        children = "inventory";
        element = "availability";
      }
    }
    return dispatch({
      type: TOGGLE_CHILDREN,
      ticker,
      baseTicker,
      children,
      closeOthers,
      activeOnly,
      oneTime,
      element,
    });
  };
}

export function loadCountries() {
  return {
    type: LOAD_COUNTRIES,
  };
}

export function loadCountriesSuccess(countries) {
  return {
    type: LOAD_COUNTRIES_SUCCESS,
    countries,
  };
}

export function loadCountriesError() {
  return {
    type: LOAD_COUNTRIES_ERROR,
  };
}

export function getCountries(locale) {
  return (dispatch, getState) => {
    dispatch(loadCountries());
    requestCountries({ dispatch, getState }, { locale })
      .then(countries => {
        dispatch(loadCountriesSuccess(fromJS(countries)));
      })
      .catch(err => {
        console.log("ERROR");
        console.log(err);
        dispatch(loadCountriesError());
      });
  };
}

export function createdReservation(resource, paymentType) {
  return {
    type: CREATED_RESERVATION,
    resource,
    paymentType,
  };
}

export function setTrackingData(resource) {
  return {
    type: SET_TRACKING_DATA,
    resource,
  };
}

export function isLoaded(globalState) {
  return globalState[name] && globalState[name].get("loaded");
}

export function requestBookingEngineData(params, sessionData) {
  return dispatch => {
    return dispatch({
      types: [
        LOAD_BOOKING_ENGINE_DATA,
        LOAD_BOOKING_ENGINE_DATA_SUCCESS,
        LOAD_BOOKING_ENGINE_DATA_ERROR,
      ],
      promise: () => fetchBookingEngineData(params, dispatch, sessionData),
    });
  };
}

export function changeConfiguration({ propertyTicker, configuration: newConfiguration }) {
  return (dispatch, getState) => {
    const configuration = getState()[name].get("configuration");
    const mergedConfiguration =
      (configuration && configuration.merge && configuration.merge(newConfiguration).toJS()) ||
      newConfiguration;
    const ARIRequestParams = buildARIRequestParams(mergedConfiguration);
    const storedParams = getFromLocalStorage(constants.LOCAL_STORAGE_KEYS.ARI_REQUEST_PARAMS) || {};
    saveToLocalStorage(constants.LOCAL_STORAGE_KEYS.ARI_REQUEST_PARAMS, {
      ...storedParams,
      ["params"]: ARIRequestParams && ARIRequestParams.localStorage,
    }); // Persisting ARI Request in session storage

    const propertyStoredParams =
      getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.PROPERTY_ARI_REQUEST_PARAMS) || {};
    propertyStoredParams[propertyTicker] = ARIRequestParams && ARIRequestParams.sessionStorage;
    saveToSessionStorage(constants.LOCAL_STORAGE_KEYS.PROPERTY_ARI_REQUEST_PARAMS, {
      ...propertyStoredParams,
    }); // Persisting ARI Request in session storage

    if (newConfiguration.currency) {
      saveToLocalStorage(constants.LOCAL_STORAGE_KEYS.CURRENCY, mergedConfiguration.currency);
    }
    return dispatch({
      type: CHANGE_CONFIGURATION,
      newConfiguration,
    });
  };
}

export function requestARI({
  propertyTicker,
  callingTicker,
  newConfiguration,
  track = false,
  sessionId,
}) {
  return (dispatch, getState) => {
    const oldConfiguration = getState()[name].get("configuration").toJS();
    const configuration = { ...oldConfiguration, ...newConfiguration };
    const ARIRequestParams = buildARIRequestParams(configuration);
    const occupationAlternatives =
      configuration.showOccupationAlternatives &&
      configuration.showOccupationAlternatives !== constants.SHOW_OCCUPATION_ALTERNATIVES.HIDE;
    const restoredSession = getState()[name].get("restoredSession");
    return dispatch({
      types: [LOAD_ARI, LOAD_ARI_SUCCESS, LOAD_ARI_ERROR],
      promise: () => {
        return Promise.all([
          fetchARI(propertyTicker, {
            ...ARIRequestParams.localStorage,
            ...ARIRequestParams.sessionStorage,
            ipInfo: configuration.ipInfo,
            sessionId,
          }),
          occupationAlternatives
            ? fetchARI(propertyTicker, {
                ...ARIRequestParams.localStorage,
                ...ARIRequestParams.sessionStorage,
                ipInfo: configuration.ipInfo,
                ignoredConfiguration: true,
                sessionId,
              })
            : Promise.resolve(null),
        ])
          .then(data => {
            if (track) {
              sendQuery(
                buildQueryTrackData({
                  ARI: data,
                  ariRequestParams: {
                    ...ARIRequestParams.localStorage,
                    ...ARIRequestParams.sessionStorage,
                  },
                  configuration,
                  propertyTicker,
                })
              ).then(() => console.debug("tracked ARI request"));
            }
            if (newConfiguration) {
              dispatch(
                changeConfiguration({ propertyTicker, configuration: fromJS(newConfiguration) })
              );
              const reservations = getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.CART);
              if (
                reservations &&
                reservations[propertyTicker] &&
                reservations[propertyTicker].length > 0
              ) {
                dispatch(
                  reservationManagerActions.updateReservationARI({
                    reservations: reservations[propertyTicker],
                    locale: newConfiguration.locale || configuration.locale,
                    sessionId,
                  })
                );
              }
            }
            return { data: data, callingTicker };
          })
          .catch(err => {
            console.log("ERROR requestARI");
            console.log(err);
          });
      },
    });
  };
}

export function receivedBookingEngineDataError(error) {
  return {
    type: LOAD_BOOKING_ENGINE_DATA_ERROR,
    error,
  };
}

export function changePropertyTicker(propertyTicker) {
  return {
    type: CHANGE_PROPERTY_TICKER,
    propertyTicker,
  };
}

// TODO: MOVE TO ReservationManager
export function requestReservationData(params) {
  const reservationId = params.reservationId;
  const propertyTicker = params.hotelTicker;
  const locale = params.locale;
  return {
    types: [LOAD_RESERVATION_DATA, LOAD_RESERVATION_DATA_SUCCESS, LOAD_RESERVATION_DATA_ERROR],
    promise: () => requestReservation({}, { reservationId, propertyTicker, locale }),
  };
}

export function changeLocale({ propertyTicker, locale, sessionId }) {
  return (dispatch, getState) => {
    if (global.window && document) {
      document.getElementsByTagName("html")[0].setAttribute("lang", locale);
    }
    const restoredSession = getState()[name].get("restoredSession");
    const sessionId = restoredSession?.id;
    dispatch(changeLocaleIntl(locale));
    const reservations = getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.CART);
    if (reservations && reservations[propertyTicker] && reservations[propertyTicker].length > 0) {
      dispatch(
        reservationManagerActions.validateReservations({
          reservations: reservations[propertyTicker],
          locale,
          propertyTicker,
        })
      );
    }

    const configuration = getState()[name].get("configuration").toJS();
    const ARIRequestParams = buildARIRequestParams(configuration);
    const occupationAlternatives =
      configuration.showOccupationAlternatives &&
      configuration.showOccupationAlternatives !== constants.SHOW_OCCUPATION_ALTERNATIVES.HIDE;

    dispatch({
      types: [LOAD_ARI, LOAD_LOCALE_DATA_SUCCESS, LOAD_BOOKING_ENGINE_DATA_ERROR],
      promise: () =>
        Promise.all([
          fetchPropertyData(propertyTicker, locale, sessionId),
          fetchARI(propertyTicker, {
            ...ARIRequestParams.localStorage,
            ...ARIRequestParams.sessionStorage,
            ipInfo: configuration.ipInfo,
            sessionId,
          }),
          occupationAlternatives
            ? fetchARI(propertyTicker, {
                ...ARIRequestParams.localStorage,
                ...ARIRequestParams.sessionStorage,
                ipInfo: configuration.ipInfo,
                ignoredConfiguration: true,
                sessionId,
              })
            : Promise.resolve(null),
        ]),
    });
  };
}

export function analyticsLoaded() {
  return {
    type: LOAD_ANALYTICS_SUCCESS,
  };
}

export function tripAdvisorLoaded() {
  return {
    type: LOAD_TRIPADVISOR_SUCCESS,
  };
}

export function externalMarkupLoaded() {
  return {
    type: LOAD_EXTERNAL_MARKUP_SUCCESS,
  };
}

export function clearData() {
  return {
    type: CLEAR_DATA,
  };
}

export function clearLoadedReservations() {
  return {
    type: CLEAR_LOADED_RESERVATIONS,
  };
}

export function globalLoading(active) {
  return {
    type: active ? GLOBAL_LOADING_ON : GLOBAL_LOADING_OFF,
  };
}

export function togglePromotions() {
  return {
    type: TOGGLE_PROMOTIONS,
  };
}

export function toggleBookingFormSummary() {
  return {
    type: TOGGLE_BOOKING_FORM_SUMMARY,
  };
}

export const actions = {
  LOAD_BOOKING_ENGINE_DATA,
  LOAD_BOOKING_ENGINE_DATA_SUCCESS,
  LOAD_BOOKING_ENGINE_DATA_ERROR,
  LOAD_RESERVATION_DATA_SUCCESS,
  LOAD_RESERVATION_DATA_ERROR,
  LOAD_RESERVATION_DATA,
  LOAD_COUNTRIES,
  LOAD_COUNTRIES_SUCCESS,
  LOAD_COUNTRIES_ERROR,
  LOAD_ANALYTICS_SUCCESS,
  LOAD_TRIPADVISOR_SUCCESS,
  LOAD_EXTERNAL_MARKUP_SUCCESS,
  CLEAR_DATA,
  TOGGLE_CHILDREN,
  SELECT_DISPLAY_ELEMENT,
  childrenToggled,
  changePropertyTicker,
  requestReservationData,
  requestARI,
  changeConfiguration,
  clearData,
  clearLoadedReservations,
  changeLocale,
  globalLoading,
  getCountries,
  createdReservation,
  setTrackingData,
  analyticsLoaded,
  tripAdvisorLoaded,
  externalMarkupLoaded,
  togglePromotions,
  toggleBookingFormSummary,
};

/* TODO: USE CONSTANTS!! */
export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_LOADED_RESERVATIONS:
      return state.set("reservation", null);
    case CLEAR_DATA:
      removeFromSessionStorage(constants.LOCAL_STORAGE_KEYS.RESERVATION_ID);

      return state
        .set("paymentTypes", false)
        .set("reservationCreated", false)
        .set("reservationLoaded", false)
        .set("analyticsLoaded", false)
        .set("tripAdvisorLoaded", false)
        .set("externalMarkupLoaded", false);
    case GLOBAL_LOADING_ON:
      return state.set("globalLoading", true);
    case GLOBAL_LOADING_OFF:
      return state.set("globalLoading", false);
    case LOAD_LOCALE_DATA_SUCCESS:
      const [propertyData, ARI, ARIAll] = action.result;
      return state
        .set("propertyData", fromJS(propertyData))
        .set(constants.PROPERTY_ARI_KEY, fromJS(ARI))
        .set(constants.PROPERTY_ARI_ALL_KEY, ARIAll ? fromJS(ARIAll) : null)
        .set("ariLoading", false)
        .set("loaded", true)
        .set("error", false);
    case LOAD_BOOKING_ENGINE_DATA_SUCCESS:
      const configuration = action.result.configuration;

      //If we have a restored session, override some config values with what's coming from it
      let session = {};
      if (state.get("restoredSession") && state.get("restoredSession").size) {
        session = state.get("restoredSession").toJS();
        const startDate = get(session, "ariRequest.start");
        if (startDate) configuration.startDate = new Date(startDate);
        const endDate = get(session, "ariRequest.end");
        if (endDate) configuration.endDate = new Date(endDate);
        const adults = get(session, "ariRequest.adults");
        if (adults) configuration.ADULT = adults;
        const seniors = get(session, "ariRequest.seniors");
        if (seniors) configuration.SENIOR = seniors;
        const teenagers = get(session, "ariRequest.teenagers");
        if (teenagers) configuration.TEENAGER = teenagers;
        const children = get(session, "ariRequest.children");
        if (children) configuration.CHILD = children;
        const babies = get(session, "ariRequest.babies");
        if (babies) configuration.BABY = babies;

        const guestAges = get(session, "ariRequest.guestAges");
        if (guestAges) configuration.guestAges = guestAges;

        saveAriParamsToStorage(configuration, action.result.propertyTicker);
      }

      // selectedTab is a param that comes from the frontend and must not be overwritten by
      // the response from the API
      if (state.get("configuration")) {
        configuration.selectedTab = state.get("configuration").get("selectedTab");
      }

      return state
        .set("restoredSession", session)
        .set("configuration", fromJS(configuration))
        .set("propertyData", fromJS(action.result.propertyData))
        .set(constants.PROPERTY_ARI_KEY, fromJS(action.result.ARI))
        .set(
          constants.PROPERTY_ARI_ALL_KEY,
          action.result.ARIAll ? fromJS(action.result.ARIAll) : null
        )
        .set("propertyTicker", action.result.propertyTicker)
        .set("loading", false)
        .set("loaded", true)
        .set("error", false);
    case LOAD_BOOKING_ENGINE_DATA_ERROR:
      return state.set("properties", false).set("loading", false).set("error", action.error);
    case LOAD_BOOKING_ENGINE_DATA:
      return state.set("properties", false).set("loading", false).set("error", false);
    case LOAD_ARI_SUCCESS:
      const [ari, ariAll] = action.result.data;
      return state
        .set(constants.PROPERTY_ARI_KEY, fromJS(ari))
        .set(constants.PROPERTY_ARI_ALL_KEY, ariAll ? fromJS(ariAll) : null)
        .set("ariLoading", false);
    case LOAD_ARI_ERROR:
      return state.set("error", action.error).set("ariLoading", false);
    case LOAD_ARI:
      return state.set("ariLoading", true);
    case CHANGE_PROPERTY_TICKER:
      return state.set("propertyTicker", action.propertyTicker);
    case CHANGE_CONFIGURATION:
      const mergedConfiguration =
        (state.get("configuration") &&
          state.get("configuration").merge &&
          state.get("configuration").merge(action.newConfiguration)) ||
        action.newConfiguration;

      return state.set("configuration", mergedConfiguration);
    case CHANGE_LOCALE:
      return state.set(
        "configuration",
        state.get("configuration").merge({ locale: action.locale })
      );
    case LOAD_RESERVATION_DATA_SUCCESS:
      return state
        .set("reservation", fromJS(action.result))
        .set("reservationLoading", false)
        .set("reservationLoaded", true)
        .set("reservationError", false);
    case LOAD_RESERVATION_DATA_ERROR:
      return state
        .set("reservationLoaded", true)
        .set("reservationLoading", false)
        .set("reservationError", action.error);
    case LOAD_RESERVATION_DATA:
      return state
        .set("reservationLoaded", false)
        .set("reservationLoading", true)
        .set("reservationError", false);
    case LOAD_COUNTRIES_SUCCESS:
      return state.set("countries", action.countries);
    case LOAD_ANALYTICS_SUCCESS:
      return state.set("analyticsLoaded", true);
    case LOAD_TRIPADVISOR_SUCCESS:
      return state.set("tripAdvisorLoaded", true);
    case LOAD_EXTERNAL_MARKUP_SUCCESS:
      return state.set("externalMarkupLoaded", true);
    case CREATED_RESERVATION:
      const paymentTypesList = [
        constants.PAYMENT_TYPES.PNP_TOKEN,
        constants.PAYMENT_TYPES.PAY_NO_PAIN_V2,
        constants.PAYMENT_TYPES.PAY_NO_PAIN_PROXY,
        constants.PAYMENT_TYPES.SIPAY_TOKENIZED_VAULT,
        constants.PAYMENT_TYPES.MERCADOPAGO,
        constants.PAYMENT_TYPES.PAYPAL_EXPRESS_CHECKOUT,
        constants.PAYMENT_TYPES.POS,
      ];
      if (action.resource && paymentTypesList.indexOf(action.paymentType) !== -1) {
        saveToSessionStorage(
          constants.LOCAL_STORAGE_KEYS.RESERVATION_ID,
          action.resource.split("/").pop()
        );
      }

      return state.set("reservationResource", action.resource).set("reservationCreated", true);
    case SET_TRACKING_DATA:
      const newTrackingData = state.get("trackingData");
      if (action.resource) {
        if (action.resource.gaClientId) {
          newTrackingData.gaClientId = action.resource.gaClientId;
        }
        if (action.resource.gaReferrer) {
          newTrackingData.gaReferrer = action.resource.gaReferrer;
        }
        if (action.resource.host) {
          newTrackingData.host = action.resource.host;
        }
      }

      return state.set("trackingData", action.resource);

    case TOGGLE_PROMOTIONS:
      return state.set("expandedPromotions", !state.get("expandedPromotions"));

    case TOGGLE_BOOKING_FORM_SUMMARY:
      return state.set("isBookingFormSummaryOpened", !state.get("isBookingFormSummaryOpened"));

    default:
      return state;
  }
};
